// ADR-006 federation contract value — single source of truth.
export const NON_PHARMA_ORIGIN = "non_pharma" as const;

export type ProductOrigin = typeof NON_PHARMA_ORIGIN | "pharma";

type ExternalReferenceLike = { readonly origin: string };

export function getProductOrigin(
  externalReferences: ReadonlyArray<ExternalReferenceLike> | null | undefined,
): ProductOrigin {
  if (!externalReferences) {
    return "pharma";
  }
  return externalReferences.some((ref) => ref.origin === NON_PHARMA_ORIGIN)
    ? NON_PHARMA_ORIGIN
    : "pharma";
}
